import React, { Suspense, lazy } from 'react';

// Витрина клиентского домена: описание сервиса, тарифы, оплата, контакты. Она же
// тянет за собой lib/company.js с реквизитами юрлица.
//
// 🔴 ИЗМЕРЕНО 04.09.2026, и результат противоположен ожиданию: динамический
// `import()` внутри ложной ветки НЕ убирает чанк из сборки. Разделение кода webpack
// делает по графу модулей, до минификации; терсер потом сворачивает ветку внутри
// чанка, но сам файл уже создан и лежит в build/static/js. Замер: сборка onprem
// вынесла реквизиты из main.js, но оставила их в четырёх .chunk.js.
// Что это даёт и чего не даёт: клиент, открывший приложение, договор не скачивает —
// чанк не запрашивается. Но файл лежит у него на диске, и `grep` по build/ находит
// ИНН. Настоящее решение — не отдавать эти данные модулем JS вовсе;
// см. docs/backlog/client-edition-split.md.
const IS_SAAS = (process.env.REACT_APP_EDITION || 'saas') !== 'onprem';

const loadLanding = () => import('./LandingPage');
const LandingPage = IS_SAAS ? lazy(loadLanding) : null;

// Код витрины — до рендера: она уже на экране готовым HTML (scripts/prerender.js),
// и пустой кадр на время загрузки был бы миганием. Отказ не ошибка.
export const preloadLanding = () => (IS_SAAS ? loadLanding() : Promise.resolve())
  .then(() => undefined, () => undefined);

export default function ClientLanding({ authSlot }) {
  // В издании onprem витрины нет. Ветка недостижима (клиентского домена там не
  // бывает), но если сюда всё же попадут — отдаём вход, а не пустой экран.
  if (!LandingPage) return authSlot || null;
  return (
    <Suspense fallback={<div className="py-16" />}>
      <LandingPage authSlot={authSlot} />
    </Suspense>
  );
}
